import {NgOptimizedImage} from "@angular/common";
import {Component} from "@angular/core";

@Component({
  selector: "app-large-logo-shear",
  templateUrl: "./large-logo-shear.component.html",
  imports: [
    NgOptimizedImage,
  ],
})
// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class LargeLogoShearComponent {
}
